<template>
  <div id="login-section" :class="pageKey === 'market' || pageKey === 'sosoceo' || pageKey === 'kaorder' ? 'no-result' : 'no-result card main'" :style="border === true ? 'border:none;box-shadow:none;padding:0px;margin:0px;' : ''"> 
    <span class="link" @click="this.$emit('login')">{{ contentData.title }}</span><br><br>
    <span style="font-size: 15px;"><label class="link" @click="this.$emit('login')">{{ contentData.obj }}</label>{{ contentData.desc }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  
  props: {
    border:Boolean,
    pageKey:String
  },
  setup(props) {
    const { t } = useI18n()

    const contents = new Map([
      ['dashboard', { title: `${t('menu.summary')}`, obj: `${t('menu.signup')} / ${t('menu.login')}`, desc: `${t('sentence.toView')}` }],
      ['list', { title: `${t('menu.details')}`, obj: `${t('menu.signup')} / ${t('menu.login')}`, desc: `${t('sentence.toView')}` }],
      ['sosoceo', { title: '게임 참여', obj: `${t('menu.signup')} / ${t('menu.login')}`, desc: `${t('sentence.toUse')}` }],
      ['kaorder', { title: `${t('menu.summary')}`, obj: `${t('menu.signup')} / ${t('menu.login')}`, desc: `${t('sentence.toView')}` }],
      ['market', { title: `${t('menu.reg')}`, obj: `${t('menu.lister')}`, desc: ` ${t('order.msg37')}`}],
      ['order', { title: `${t('menu.requestOrder')}`, obj: `${t('menu.requester')}`, desc: ` ${t('order.msg37')}`}],
      ['qna', { title: `${t('menu.qna')}`, obj: `${t('menu.inquirer')}`, desc: ` ${t('order.msg37')}`}],
      ['write', { title: `${t('menu.write')}`, obj: `${t('menu.writer')}`, desc: ` ${t('order.msg37')}`}],
      ['bulk', { title: `${t('menu.bulkReg')}`, obj: `${t('menu.login')}`, desc: ` ${t('order.msg37')}`}],
      ['shop', { title: ` ${t('order.msg38')}`, obj: `${t('menu.signup')} / ${t('menu.login')}`, desc: `${t('sentence.toUse')}`}],
      ['contract', { title: `${t('menu.signup')} / ${t('menu.login')}`, obj: `${t('menu.signup')} / ${t('menu.login')}`, desc: `${t('sentence.toUse')}` }]
    ])
    const defaultContent = {
      title: `${t('menu.signup')} / ${t('menu.login')}`,
      obj: `${t('menu.signup')} / ${t('menu.login')}`,
      desc: `${t('sentence.toUse')}`
    }

    const contentData = computed(() => {
      return contents.get(props.pageKey) || defaultContent
    })
    return {
      contentData
    }
  }
}
</script>
<style scoped>
  #login-section {
    font-size:20px;
    font-weight:bold;
  }
</style>
